import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Card, Col, Modal, notification, Row } from "antd";

import { POST } from "../../../../providers/useAxiosQuery";
import { userData } from "../../../../providers/companyInfo";
import {
	checkNetworkStatus,
	readFile,
	setFileStorage,
} from "../../../../providers/useCapacitorStorage";
import notificationErrors from "../../../../providers/notificationErrors";
import QuestionContentPreview from "./QuestionContentPreview";
import dayjs from "dayjs";

export default function ModalPreviewAnswer(props) {
	const { toggleModalPreview, setToggleModalPreview, dataSource, answers } =
		props;

	const navigate = useNavigate();

	const [isLoadingSurvey, setIsLoadingSurvey] = useState(false);

	const { mutate: mutateSurvey } = POST(
		`api/form_question_answer_batch`,
		"form_question_answer_single_store",
	);

	const onFinishPreview = async () => {
		setIsLoadingSurvey(true);

		console.log("answers: ", answers);
		console.log("dataSource: ", dataSource);

		let form_question_categories = dataSource.form_question_categories.map(
			(item) => {
				console.log("item: ", item);

				return {
					...item,
					form_questions: item.form_questions.map((item2) => {
						console.log("item.form_questions: ", item2);

						let id = `q_${item2.id}`;

						let answer = extractQuestionAnswer(id, item2.question_type);
						console.log("answer: ", answer);

						let form_question_options = extractQuestionOptionAnswer(
							id,
							item.form_id,
							item.id,
							item2.id,
							null,
							item2.form_question_options,
						);

						console.log("form_question_options: ", form_question_options);

						return {
							...item2,
							user_id: userData().id,
							form_id: item.form_id,
							form_question_category_id: item.id,
							form_question_id: item2.id,
							answer: answer,
							form_question_options: form_question_options,
						};
					}),
				};
			},
		);

		console.log("form_question_categories: ", form_question_categories);

		let dataAnswers = [];
		form_question_categories.forEach((item) => {
			item.form_questions.forEach((item2) => {
				dataAnswers.push({
					user_id: userData().id,
					form_id: item2.form_id,
					form_question_category_id: item2.form_question_category_id,
					form_question_id: item2.form_question_id,
					answer: item2.answer,
				});

				if (item2.form_question_options.length) {
					dataAnswers = dataAnswers.concat(
						extractSubAnswerToSave(item2.form_question_options),
					);
				}
			});
		});

		let currentLocations = localStorage.getItem("currentLocations")
			? JSON.parse(localStorage.getItem("currentLocations"))
			: {};

		let coords =
			currentLocations && currentLocations.coords
				? currentLocations.coords
				: {};

		let data_survey_pending_list_to_save = {
			...dataSource,
			batch: {
				user_id: userData().id,
				form_id: dataSource.id,
				latitude: coords.latitude,
				longitude: coords.longitude,
				accuracy: coords.accuracy,
				altitude: coords.altitude,
				heading: coords.heading,
				altitude_accuracy: coords.altitudeAccuracy,
				speed: coords.speed,
				date_end_answer: dayjs().format("YYYY-MM-DD HH:mm:ss"),
				date_start_answer: dayjs().format("YYYY-MM-DD HH:mm:ss"),
			},
			form_question_categories,
			survey_status: "Ready to Upload",
		};

		try {
			let resCheckNetworkStatus = await checkNetworkStatus();
			console.log("dataAnswers: ", dataAnswers);

			if (resCheckNetworkStatus?.connected) {
				// connected
				mutateSurvey(
					{
						answer_list: dataAnswers,
						batch: {
							user_id: userData().id,
							form_id: dataSource.id,
							latitude: coords.latitude,
							longitude: coords.longitude,
							accuracy: coords.accuracy,
							altitude: coords.altitude,
							heading: coords.heading,
							altitude_accuracy: coords.altitudeAccuracy,
							speed: coords.speed,
							date_end_answer: dayjs().format("YYYY-MM-DD HH:mm:ss"),
							date_start_answer: dayjs().format("YYYY-MM-DD HH:mm:ss"),
						},
					},
					{
						onSuccess: (res2) => {
							if (res2.success) {
								notification.success({
									message: "Survey",
									description: res2.message,
								});
							} else {
								notification.error({
									message: "Survey",
									description: res2.message,
								});
								readSaveToFile(
									data_survey_pending_list_to_save,
									"Server error occurred and your data has been saved on this device",
								);
							}
							setIsLoadingSurvey(false);
							triggerPendingUpdate();
							navigate(-1);
						},
						onError: (err) => {
							setIsLoadingSurvey(false);
							notificationErrors(err);
							readSaveToFile(
								data_survey_pending_list_to_save,
								"Server error occurred and your data has been saved on this device.",
							);
							triggerPendingUpdate();
							navigate(-1);
						},
					},
				);
			} else {
				readSaveToFile(data_survey_pending_list_to_save);
				navigate(-1);
			}
		} catch (error) {
			readSaveToFile(
				data_survey_pending_list_to_save,
				"Connection lost, and your data has been saved on this device.",
			);
			navigate(-1);
		}
	};

	const triggerPendingUpdate = () => {
		window.dispatchEvent(new Event("survey-pending-updated"));
	};

	const readSaveToFile = async (data, message) => {
		try {
			let data_survey_pending_list = await readFile(
				`fsuu_dsac_survey_diosys/survey_pending_list_${userData().id}.txt`,
			);

			if (data_survey_pending_list && data_survey_pending_list.data) {
				data_survey_pending_list = JSON.parse(data_survey_pending_list.data);

				data_survey_pending_list.push(data);

				setFileStorage(
					"fsuu_dsac_survey_diosys",
					`survey_pending_list_${userData().id}`,
					data_survey_pending_list,
				).then(() => {
					setIsLoadingSurvey(false);
					notification.info({
						message: "Survey",
						description: message,
					});

					triggerPendingUpdate();
				});
			} else {
				setFileStorage(
					"fsuu_dsac_survey_diosys",
					`survey_pending_list_${userData().id}`,
					[data],
				).then(() => {
					setIsLoadingSurvey(false);
					notification.info({
						message: "Survey",
						description: message,
					});

					triggerPendingUpdate();
				});
			}
		} catch (error) {
			setFileStorage(
				"fsuu_dsac_survey_diosys",
				`survey_pending_list_${userData().id}`,
				[data],
			).then(() => {
				setIsLoadingSurvey(false);
				notification.info({
					message: "Survey",
					description: message,
				});
				triggerPendingUpdate();
			});
		}
	};

	const extractSubAnswerToSave = (form_question_options) => {
		let sub_answers = [];
		form_question_options.forEach((item) => {
			sub_answers.push({
				answer: item.answer,
				form_id: item.form_id,
				form_question_category_id: item.form_question_category_id,
				form_question_id: item.form_question_id,
				form_question_option_id: item.form_question_option_id,
				form_question_sub_option_id: item.form_question_sub_option_id,
				user_id: item.user_id,
			});
			if (item.form_question_options.length) {
				let sub_answers_copy = extractSubAnswerToSave(
					item.form_question_options,
				);
				sub_answers = sub_answers.concat(sub_answers_copy);
			}
		});
		return sub_answers;
	};

	const extractQuestionAnswer = (id, type) => {
		console.log("extractQuestionAnswer: ", id, type);

		switch (type) {
			case "Text (Input)":
			case "Number (Input)":
			case "Select (Dropdown)":
			case "Date (Datepicker)":
			case "Time (Timepicker)":
			case "Radio (Button)":
			case "Checkbox":
				let answer = null;

				console.log("extractQuestionAnswer answers: ", answers);
				Object.keys(answers).forEach((key) => {
					if (!key.includes("_other")) {
						if (answers[key] !== undefined) {
							if (key === id) {
								console.log("type, answers[key]: ", type, answers[key]);

								answer = checkTypeAnswer(type, answers[key]);
							}
						}
					}
				});

				Object.keys(answers).forEach((key) => {
					if (key.includes("_other")) {
						if (answers[key] !== undefined) {
							console.log("type, answers[key]: ", type, answers[key]);
							let q_id = key.split("_other")[0];
							if (q_id === id) {
								answer += ": " + answers[key];
							}
						}
					}
				});

				console.log("extractQuestionAnswer answer: ", answer);

				return answer;
			default:
				return null;
		}
	};
	const extractQuestionOptionAnswer = (
		id,
		form_id,
		form_question_category_id,
		form_question_id,
		form_question_option_id,
		form_question_options,
	) => {
		let new_form_question_options = [];
		form_question_options.forEach((item) => {
			console.log("extractQuestionOptionAnswer form_question_options: ", item);

			if (item.sub_option_type) {
				console.log(
					"extractQuestionOptionAnswer {id}_qo_{item.id}",
					`${id}_qo_${item.id}`,
				);
				console.log("extractQuestionOptionAnswer 1 answers", answers);

				let answer = extractQuestionAnswer(
					`${id}_qo_${item.id}`,
					item.sub_option_type,
				);

				console.log(
					"extractQuestionOptionAnswer 2 answers[`{id}_qo_{item.id}`]: ",
					answers[`${id}_qo_${item.id}`]
						? answers[`${id}_qo_${item.id}`]
						: "nnnn",
					item.sub_option_type,
				);

				if (
					answers[`q_${item.form_question_id}`] &&
					(answers[`${id}_qo_${item.id}`] === undefined ||
						answers[`${id}_qo_${item.id}`] === null)
				) {
					answer = answers[`q_${item.form_question_id}`];
				}

				console.log("extractQuestionOptionAnswer 3 answer: ", answer);

				let form_question_options = extractQuestionOptionAnswer(
					`${id}_qo_${item.id}`,
					form_id,
					form_question_category_id,
					form_question_id,
					item.id,
					item.form_question_options,
				);

				new_form_question_options.push({
					user_id: userData().id,
					form_id,
					form_question_category_id,
					form_question_id,
					form_question_option_id: form_question_option_id ?? item.id,
					form_question_sub_option_id: form_question_option_id ? item.id : null,
					option: item.option,
					sub_option_type: item.sub_option_type,
					sub_options: item.sub_options,
					answer,
					form_question_options: form_question_options,
				});
			}
		});

		return new_form_question_options;
	};

	const checkTypeAnswer = (type, answer) => {
		console.log("checkTypeAnswer: ", type, answer);

		switch (type) {
			case "Text (Input)":
			case "Number (Input)":
			case "Select (Dropdown)":
				return answer;
			case "Date (Datepicker)":
				return answer ? dayjs(answer).format("YYYY-MM-DD") : null;
			case "Time (Timepicker)":
				return answer ? dayjs(answer).format("HH:mm:ss") : null;
			case "Radio (Button)":
				return answer;
			case "Checkbox":
				return JSON.stringify(answer);
			case "sub_question":
				return answer ? answer : null;
			default:
				return null;
		}
	};

	return (
		<Modal
			wrapClassName="modal-preview-answer"
			open={toggleModalPreview}
			title={dataSource && dataSource.form_name ? dataSource.form_name : ""}
			onCancel={() => setToggleModalPreview(false)}
			footer={
				<>
					<Button
						size="large"
						onClick={() => setToggleModalPreview(false)}
						disabled={isLoadingSurvey}
						className="btn-main-primary outlined br-30"
					>
						Close
					</Button>
					<Button
						size="large"
						onClick={() => onFinishPreview()}
						loading={isLoadingSurvey}
						className="btn-main-primary br-30"
					>
						Submit
					</Button>
				</>
			}
		>
			{dataSource && dataSource.form_question_categories
				? dataSource.form_question_categories.map((item, index) => {
						console.log("form_question_categories item: ", item);
						console.log("form_question_categories answers: ", answers);

						return (
							<Card key={index} title={item.category}>
								{item.form_questions && item.form_questions
									? item.form_questions.map((item2, index2) => {
											console.log("form_questions: ", item2);

											if (item2.add_another) {
												// find all answers with the same form_question_id and form_question_category_id
												const multipleAnswers = answers
													? Object.keys(answers)
															.filter(
																(key) =>
																	key === `q_${item2.id}` ||
																	(key.startsWith(`q_${item2.id}_`) &&
																		!key.includes("_qo_")),
															)
															.map((key) => ({ key, value: answers[key] }))
													: [];

												console.log(
													"form_questions multipleAnswers: ",
													multipleAnswers,
												);

												console.log("form_questions item2: ", item2);

												return (
													<Row key={index2}>
														<Col xs={24} sm={24} md={24} lg={24} xl={24}>
															{multipleAnswers.length > 0 ? (
																multipleAnswers.map((ans, ansIndex) => {
																	console.log("form_questions ans: ", ans);

																	return (
																		<QuestionContentPreview
																			key={ansIndex}
																			category={item.category}
																			id={[ans.key]}
																			question={`${item2.question}${
																				multipleAnswers.length > 1
																					? ` (${ansIndex + 1})`
																					: ""
																			}`}
																			description={item2.description}
																			type={item2.question_type}
																			form_question_options={
																				item2.form_question_options.length
																					? item2.form_question_options
																					: []
																			}
																			answers={answers}
																			item2={item2}
																		/>
																	);
																})
															) : (
																<QuestionContentPreview
																	category={item.category}
																	id={[`q_${item2.id}`]}
																	question={item2.question}
																	description={item2.description}
																	type={item2.question_type}
																	form_question_options={
																		item2.form_question_options.length
																			? item2.form_question_options
																			: []
																	}
																	answers={answers}
																	item2={item2}
																/>
															)}
														</Col>
													</Row>
												);
											}

											return (
												<Row key={index2}>
													<Col xs={24} sm={24} md={24} lg={24} xl={24}>
														<QuestionContentPreview
															category={item.category}
															id={[`q_${item2.id}`]}
															question={item2.question}
															description={item2.description}
															type={item2.question_type}
															form_question_options={
																item2.form_question_options.length
																	? item2.form_question_options
																	: []
															}
															answers={answers}
															item2={item2}
														/>
													</Col>
												</Row>
											);
									  })
									: ""}
							</Card>
						);
				  })
				: ""}
		</Modal>
	);
}
